import {
  createAsyncThunk,
  createEntityAdapter,
  createSlice,
} from "@reduxjs/toolkit";
import {
  getMainStock,
  getMainStockHistory,
  mainStockLogs,
  mainStockTransaction,
} from "data/server_apis/inventoryService";

const mainStockAdapter = createEntityAdapter({
  selectId: (mainStock) => mainStock.id,
});

const mainStockLogAdapter = createEntityAdapter({
  selectId: (log) => log.id,
});

export const mainStockTransactionThunk = createAsyncThunk(
  "mainStock/create",
  async ({ stock, data }, { rejectWithValue }) => {
    try {
      return (await mainStockTransaction(data)).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);
export const getMainStockLogsThunk = createAsyncThunk(
  "mainStockLogs/get",
  async ({ page, from_date, to_date }, { rejectWithValue }) => {
    try {
      return (await mainStockLogs(page, from_date, to_date)).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

export const getMainStockThunk = createAsyncThunk(
  "mainStock/get",
  async (_, { rejectWithValue }) => {
    try {
      return (await getMainStock()).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

export const getMainStockHistoryThunk = createAsyncThunk(
  "mainStockHistory/get",
  async (time, { rejectWithValue }) => {
    try {
      return (await getMainStockHistory(time)).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

const mainStockSlice = createSlice({
  name: "mainStack",
  initialState: mainStockAdapter.getInitialState({
    mainStockStatus: {},
    mainStockTransactionStatus: {},
    logs: mainStockLogAdapter.getInitialState(),
    logStatus: {},
    logPageCount: 1,
    history: [],
    historyStatus: {},
  }),
  reducers: {
    clearMainStockState: (state, action) => {
      state.mainStockTransactionStatus = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(mainStockTransactionThunk.pending, (state, action) => {
        state.mainStockTransactionStatus = { loading: "post" };
      })
      .addCase(mainStockTransactionThunk.rejected, (state, action) => {
        state.mainStockTransactionStatus = {
          error: "post",
          errorMessage: action.payload?.message,
        };
      })
      .addCase(mainStockTransactionThunk.fulfilled, (state, action) => {
        state.mainStockTransactionStatus = {
          success: "post",
          errorMessage: action.payload?.message,
        };
        if (
          action.meta.arg.data.in_or_out === "ret" ||
          action.meta.arg.data.in_or_out === "out"
        ) {
          const stock = { ...action.meta.arg.stock };
          stock.qty -= action.payload.qty;
          mainStockAdapter.updateOne(state, {
            id: action.meta.arg.stock.id,
            changes: stock,
          });
        }
      });

    builder
      .addCase(getMainStockThunk.pending, (state, action) => {
        state.mainStockStatus = { loading: "get" };
      })
      .addCase(getMainStockThunk.rejected, (state, action) => {
        state.mainStockStatus = {
          error: "get",
          errorMessage: action.payload?.message,
        };
      })
      .addCase(getMainStockThunk.fulfilled, (state, action) => {
        state.mainStockStatus = {
          success: "get",
        };
        mainStockAdapter.setAll(state, action.payload);
      });

    builder.addCase(getMainStockLogsThunk.fulfilled, (state, action) => {
      mainStockLogAdapter.setAll(state.logs, action.payload.results);
      state.logPageCount = action.payload.total_pages;
    });

    builder
      .addCase(getMainStockHistoryThunk.pending, (state, action) => {
        state.getMainStockHistory = { loading: "get" };
      })
      .addCase(getMainStockHistoryThunk.rejected, (state, action) => {
        state.getMainStockHistory = {
          error: "get",
          errorMessage: action.payload?.message,
        };
      })
      .addCase(getMainStockHistoryThunk.fulfilled, (state, action) => {
        state.getMainStockHistory = {
          success: "get",
        };
        state.history = action.payload;
      });
  },
});

export const { clearMainStockState } = mainStockSlice.actions;
export const mainStockSelector = mainStockAdapter.getSelectors(
  (state) => state.mainStock
);

export const mainStockLogSelector = mainStockLogAdapter.getSelectors(
  (state) => state.mainStock.logs
);

export default mainStockSlice.reducer;
